import {Component, Inject, Input, OnInit} from '@angular/core';
import {Tracker} from 'shared';
import {GoldenLayoutContainer} from 'ngx-golden-layout';
import GoldenLayout from 'golden-layout';
import {TrackerService} from '../../stores/tracker.service';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'app-tracker-assignment-grid',
  templateUrl: './tracker-assignment-grid.component.html',
  styleUrls: ['./tracker-assignment-grid.component.scss']
})
export class TrackerAssignmentGridComponent implements OnInit {

  @Input()
  tracker: Tracker;
  ds: DataSource;
  constructor(
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
    private trackerService: TrackerService,
  ) {

    // Access state
    this.tracker = container.getState().tracker;

    // Create data source
    this.ds = new DataSource({
      store: new CustomStore({
        key: 'id',
        load: () => {
          return trackerService.assignments(this.tracker.id).toPromise();
        }
      }),
    });
  }

  ngOnInit(): void {
  }

}
